<template>
  <div data-component="base-settings-empty-results">
    <div class="title">
      {{ title }}
    </div>

    <div class="search-term-info">
      <template v-if="type === 'no-search-results'">
        <or-label v-if="searchText">
          <i18n path="HITL.common.search.no-results-description">
            <strong
              slot="query"
              :title="searchText"
            >
              {{ searchText }}
            </strong>
          </i18n>
        </or-label>

        <or-label>
          {{ $t('HITL.common.search.no-results-update-search') }}
        </or-label>
      </template>

      <or-label v-if="descriptionText">
        {{ descriptionText }}
      </or-label>
    </div>
  </div>
</template>

<script lang="ts">
import _ from 'lodash';
import { defineComponent, PropType } from 'vue-demi';
import { OrLabelV3 as OrLabel } from '@onereach/ui-components-25';

export default defineComponent({
  name: 'BaseSettingsEmptyResults',
  components: { OrLabel },
  props: {
    type: {
      type: String as PropType<'no-items' | 'no-search-results'>,
      default: 'no-items',
    },
    searchTerm: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  computed: {
    title() {
      return this.type === 'no-items'
        ? this.$t('HITL.common.labels.no-items')
        : this.$t('HITL.common.search.no-results');
    },

    searchText() {
      const MAX_LENGTH = 50;
      return _.truncate(this.searchTerm, { length: MAX_LENGTH });
    },

    descriptionText() {
      return this.type === 'no-items'
        ? this.description || this.$t('HITL.common.labels.no-items-description')
        : this.description;
    },
  },
});
</script>

<style lang="scss" scoped>
[data-component='base-settings-empty-results'] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: var(--s-3);

  .title {
    color: var(--or-c-on-background);
    font-weight: var(--fw-2);
  }

  .search-term-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 40rem;
  }
}
</style>
